import { ExternalLink } from 'lucide-react';
import { fmtDay, reportTypeLabel } from './SignPageShell';

const HEAD_FONT = { fontFamily: "'Exo 2', sans-serif" };

/** Who's asking, what you're signing, and the report itself (iframe). */
export function SignRequestHeader({ meta, viewUrl }) {
  const company = meta.company?.name || 'The sender';
  return (
    <>
      <section className="space-y-3 animate-in fade-in-0 slide-in-from-bottom-2 duration-300" data-testid="sign-header">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight leading-tight" style={HEAD_FONT} data-testid="sign-headline">
          {company} has requested your signature on this {reportTypeLabel(meta.report?.report_type)} report
        </h1>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-[#5C6370]">
          <span>Signing as <strong className="text-[#111417]" data-testid="sign-signer-name">{meta.signer?.name}</strong></span>
          <span>Field: <strong className="text-[#111417]" data-testid="sign-field-label">{meta.signer?.field_label}</strong></span>
          {meta.report?.job_name && <span>Job: <strong className="text-[#111417]">{meta.report.job_name}</strong></span>}
        </div>
        {meta.expires_at && <div className="text-xs text-[#8A8F99]">This link expires {fmtDay(meta.expires_at)}.</div>}
        {meta.message && (
          <blockquote className="bg-white border border-[#D5D8DD] border-l-4 border-l-[#4575A8] rounded-sm px-4 py-3 text-sm whitespace-pre-line" data-testid="sign-sender-message">
            <div className="text-[10px] font-semibold uppercase tracking-wider text-[#5C6370] mb-1">Note from {meta.sender_name || company}</div>
            {meta.message}
          </blockquote>
        )}
      </section>
      <section className="bg-white border border-[#D5D8DD] rounded-sm overflow-hidden">
        <header className="flex items-center justify-between gap-3 px-4 sm:px-6 py-3 border-b border-[#E6E8EC]">
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-wider text-[#5C6370]">Step 1</div>
            <h2 className="text-base font-bold text-[#111417]">Review {meta.report?.title || 'the report'}</h2>
          </div>
          <a href={viewUrl} target="_blank" rel="noopener noreferrer" data-testid="sign-open-full"
            className="inline-flex items-center gap-1 text-xs font-semibold text-[#4575A8] hover:text-[#5C8AC2]">
            Full screen <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </header>
        <iframe title="Report to sign" src={viewUrl} data-testid="report-sign-frame"
          className="w-full h-[65vh] sm:h-[70vh] bg-white" sandbox="allow-same-origin allow-popups" />
      </section>
    </>
  );
}

export default SignRequestHeader;
